import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, withRouter } from "react-router-dom";
import Modal from "react-modal";
import moment from "moment";
import Cookies from "universal-cookie";
import _ from "lodash";
import styled from "styled-components";
import { Translate, I18n } from "react-redux-i18n";
import { initializeEligibilityModal, updateEligibilityModalState } from "../../Store/Modals/Actions";
import { setGuestAlertStauts } from "../../Store/Account/Actions";
Modal.setAppElement("#react-app");
const cookies = new Cookies();

// region Style
const ModalBody = styled.div`
    padding: 40px 80px;
    
    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) and (max-width: 991.98px) {
        padding: 40px 20px;
    }
`;

const Img = styled.img`
    width: 120px;

    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) and (max-width: 1199.98px) {
        width: 100px;
    }
`;

const Alert = styled.div`
    margin-bottom: 20px;
    padding: 30px;
    border: none;
`;

const AlertBody = styled.div`
    ${Alert} & {
        font-size: 14pt;
        width: 100%;
    }
    
    // Extra small devices (portrait phones, less than 576px)
    @media (max-width: 575.98px) {
        font-size: 12pt;
    }
    
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) and (max-width: 1199.98px) {
        ${Alert} & {
            font-size: 12pt;
        }
    }
`;

const AlertCol = styled.div`
    ${AlertBody} & {
        // Extra small devices (portrait phones, less than 576px)
        @media (max-width: 575.98px) {
            &:not(:last-of-type) {
                margin-bottom: 20px;
            }
        }
    }
`;

const AlertHeader = styled.h4`
    ${AlertBody} & {
        font-size: 14pt;
        color: #3094B6;
    }
    
    // Extra small devices (portrait phones, less than 576px)
    @media (max-width: 575.98px) {
        ${AlertBody} & {
            font-size: 12pt;
        }
    }
    
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) and (max-width: 1199.98px) {
        ${AlertBody} & {
            font-size: 12pt;
        }
    }
`;

const AlertP = styled.p`
    ${AlertBody} & {
      color: #666;
    }
`;

const CustomRow = styled.div`
    margin-bottom: 20px;
`;

const CustomP = styled.p`
    font-size: 12pt;
    
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        font-size: 9pt;
    }
`;

const CustomPrimaryP = styled.p`
    color: #3094B6;
    font-size: 14pt;
    
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        font-size: 12pt;
    }
`;

const Feature = styled.p`
    font-size: 14pt;
    font-weight: 900;
    
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        font-size: 9pt;
        text-align: left;
        width: 100%;
        margin: 0 auto 15px auto !important;
    }
    
    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) and (max-width: 991.98px) {
        text-align: left;
        width: 350px;
        margin: 0 auto 15px auto !important;
    }
    
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) {
        margin-bottom: 20px !important;
    }
    
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) and (max-width: 1199.98px) {
        font-size: 12pt;
    }
`;

const FeatureIcon = styled.img`
    ${Feature} & {
        width: 30px;
    }
`;

const CustomSpan = styled.span`
    font-size: 12pt;
    
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        font-size: 9pt;
    }
`;

const StyledTranslate = styled(Translate)`
    color: #666 !important;
`;

const CloseButton = styled.div`
    display: block !important;
`;
// endregion

class EligibilityModal extends Component {
    constructor(props) {
        super(props);

        this.closeModal = this.closeModal.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    componentWillMount() {
        const { initializeEligibilityModal, updateEligibilityModalState, eligibilityModalInitialized, setGuestAlertStauts, userInfo } = this.props;

        if (!userInfo || _.isEmpty(userInfo)) {
            updateEligibilityModalState(false);
        } else {
            const cookie = cookies.get("skipEligibilityMsg");

            initializeEligibilityModal(true);

            if (cookie && cookie === "1" || eligibilityModalInitialized) {
                updateEligibilityModalState(false);
            } else {
                if (userInfo.isGuest){
                    setGuestAlertStauts(true);
                } else {
                    setGuestAlertStauts(false); //If modal reinstated, leave this line and remove rest of if statement
                }
                updateEligibilityModalState(false); //Changed to 'false' to remove Eligibility Modal. Change back to 'true' if needs to be reinstated.
            }
        }
    }

    componentWillUnmount() {
        const { setGuestAlertStauts, userInfo } = this.props;

        if (userInfo && userInfo.isGuest) {
            setGuestAlertStauts(true);
        }
    }

    closeModal() {
        const { updateEligibilityModalState, setGuestAlertStauts, userInfo } = this.props;

        updateEligibilityModalState(false);

        if (userInfo.isGuest) {
            setGuestAlertStauts(true);
        }
    }

    onCloseClick() {
        const skipEligibilityMsg = cookies.get("skipEligibilityMsg") === "1";

        if (!skipEligibilityMsg) {
            cookies.set("skipEligibilityMsg", "1");
        }

        this.closeModal();
    }

    onCheckboxClick(e) {
        if (e.target.checked) {
            cookies.set("skipEligibilityMsg", "1");
        } else {
            cookies.remove("skipEligibilityMsg");
        }
    }

    render() {
        const { userInfo, eligibilityModalOpen } = this.props;

        if (userInfo) {
            const eligibleToBuy = userInfo.purchaseEligibilityDate ? moment(userInfo.purchaseEligibilityDate).diff(moment(), "days") < 1 : false;
            const isCustomMessage = moment(userInfo.purchaseEligibilityDate).format("YYYY-MM-DD") === "2020-06-30";
            const purchaseEligibilityDate = isCustomMessage ? "TBD" : I18n.l(userInfo.purchaseEligibilityDate, { dateFormat: "locale.date.short" });
            const onTheRoadEligibilityDate = isCustomMessage ? "TBD" : I18n.l(userInfo.onTheRoadEligibilityDate, { dateFormat: "locale.date.short" });

            return (
                <Modal
                    isOpen={eligibilityModalOpen}
                    onRequestClose={this.closeModal}
                    contentLabel="eligibility alert"
                    className="modal-content"
                    overlayClassName="modal-container eligibility-modal modal-active"
                    shouldCloseOnOverlayClick={false}
                >
                    <ModalBody className="modal-body">
                        <div className="row justify-content-center">
                            <div className="col-md-12 text-center">
                                <div className="feature feature-1">
                                    <CustomRow className="row">
                                        <div className="col-lg-6 offset-lg-3">
                                            <div className="bar__module text-center">
                                                <Link to="#" style={{ cursor: "auto" }}>
                                                    <Img className="logo logo-light logo-desktop" alt="logo" src={require("../../../Assets/Images/logo-velocitor.png")}/>
                                                </Link>
                                            </div>
                                        </div>
                                    </CustomRow>

                                    <div className="text-block">
                                        <h3><Translate value="modals.eligibility.title" /></h3>
                                    </div>

                                    <div className="row justify-content-center">
                                        <div className="col-12 text-center">
                                            <Alert className={"alert bg--primary"}>
                                                <AlertBody className="alert__body">
                                                    <div className="row">
                                                        <AlertCol className="col-md-4">
                                                            <AlertHeader className="type--uppercase"><StyledTranslate value="modals.eligibility.station" /></AlertHeader>
                                                            <AlertP>{userInfo.station}</AlertP>
                                                        </AlertCol>
                                                        <AlertCol className="col-md-4">
                                                            <AlertHeader className="type--uppercase"><StyledTranslate value="modals.eligibility.purchaseEligibility" /></AlertHeader>
                                                            <AlertP>{purchaseEligibilityDate}</AlertP>
                                                        </AlertCol>
                                                        <AlertCol className="col-md-4">
                                                            <AlertHeader className="type--uppercase"><StyledTranslate value="modals.eligibility.onTheRoadEligibility" /></AlertHeader>
                                                            <AlertP>{onTheRoadEligibilityDate}</AlertP>
                                                        </AlertCol>
                                                    </div>
                                                </AlertBody>
                                            </Alert>
                                        </div>
                                    </div>

                                    <CustomRow className="row">
                                        <div className="col-12">
                                            <strong>
                                                <CustomPrimaryP>
                                                    <Translate value="modals.eligibility.desc1" />
                                                </CustomPrimaryP>
                                            </strong>
                                        </div>
                                    </CustomRow>

                                    <CustomRow className="row">
                                        <div className="col-12">
                                            <CustomP>
                                                <Translate value="modals.eligibility.desc21" /> <strong><Translate value="modals.eligibility.desc22" /></strong> <Translate value="modals.eligibility.desc23" />
                                            </CustomP>
                                        </div>
                                    </CustomRow>

                                    <CustomRow className="row">
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-12">
                                                    <Feature>
                                                        <FeatureIcon src={require("../../../Assets/Images/shield-check-solid.svg")} /> <Translate value="modals.eligibility.list.starV" />
                                                    </Feature>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <Feature>
                                                        <FeatureIcon src={require("../../../Assets/Images/shield-check-solid.svg")} /> <Translate value="modals.eligibility.list.vedr" />
                                                    </Feature>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Feature>
                                                        <FeatureIcon src={require("../../../Assets/Images/shield-check-solid.svg")} /> <Translate value="modals.eligibility.list.telematics" />
                                                    </Feature>
                                                </div>
                                            </div>
                                        </div>
                                    </CustomRow>

                                    <CustomRow className="row justify-content-md-center">
                                        <div className="col-md-6 text-center">
                                            <div className="input-checkbox">
                                                <input
                                                    id="dontShowAgain"
                                                    type="checkbox"
                                                    onClick={this.onCheckboxClick.bind(this)}
                                                />
                                                <label htmlFor="dontShowAgain"/>
                                            </div>
                                            <CustomSpan><Translate value="modals.eligibility.dontShow" /></CustomSpan>
                                        </div>
                                    </CustomRow>

                                    <button className="btn btn--primary type--uppercase" type="button" onClick={this.closeModal} style={{ width: 150 }}><Translate value="modals.eligibility.continueShopping" /></button>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <CloseButton className="modal-close modal-close-cross" onClick={this.onCloseClick}/>
                </Modal>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        eligibilityModalOpen: state.eligibilityModalOpen,
        eligibilityModalInitialized: state.eligibilityModalInitialized,
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateEligibilityModalState: updateEligibilityModalState,
        initializeEligibilityModal: initializeEligibilityModal,
        setGuestAlertStauts: setGuestAlertStauts
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EligibilityModal));